import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <div className="container page-content" style={{ textAlign: 'center', padding: '50px 20px' }}>
            <h1>404 - Page Not Found</h1>
            <p style={{ fontSize: '1.2rem', margin: '20px 0' }}>
                Oops! The page you are looking for does not exist or may have been moved.
            </p>
            <img
                src="/undraw_page_not_found_re_e9o6.svg" // Placeholder image, download one if you like
                alt="Page Not Found"
                style={{ maxWidth: '400px', margin: '30px auto', display: 'block' }}
            />
            <Link
                to="/"
                style={{
                    display: 'inline-block',
                    padding: '10px 20px',
                    marginTop: '20px',
                    fontSize: '1rem',
                    color: '#fff',
                    backgroundColor: '#007bff',
                    border: 'none',
                    borderRadius: '5px',
                    textDecoration: 'none',
                    cursor: 'pointer'
                }}
            >
                Go to Homepage
            </Link>
        </div>
    );
};

export default NotFoundPage; 